export const messages = {
  page: {
    title: {
      id: 'followUpPlan.TaskNotes.Title',
      defaultMessage: 'Recommended for your follow-up care',
    },
  },
};
